export const CANCELELATION_TEXT =
    'For a confirmed booking, the guest can cancel a reservation up to 2 hours before the time of the booking and receive a full refund. Within 2 hours of the time of booking, there are no cancellations.';

export const BOOKING_POLICIES = [
    'Only one booking is allowed at a time at any spot and there is an enforced 30 min buffer between all bookings to ensure dogs in separate bookings do not meet.',
    'This spot is set for Booking, which means you will be instantly confirmed for any booking you request. You will receive the address and access instruction immediately following booking.',
    'Visits can be moved or cancelled up to 2 hours before a visit.',
    'Visits can be extended and dogs can be added throughout the visit.',
];
